// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as ResponseHandler$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.bs.js";

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var title = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
  if (title.TAG === /* Ok */0) {
    var message = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "message"), null));
    if (message.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                title: title._0,
                message: message._0
              }
            };
    }
    var e = message._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".message" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = title._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".title" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

var Decode = {
  t_decode: t_decode
};

function decodeInvalidCredentials(data) {
  return /* DefaultError */{
          _0: {
            title: {
              TAG: /* UnprocessedEntity */1,
              _0: data.title
            },
            message: Belt_Option.getWithDefault(data.message, "Something went wrong!")
          }
        };
}

function execute(response) {
  if (typeof response === "number" || response.TAG !== /* UnprocessedEntity */2) {
    return ResponseHandler$Catalyst.DefaultErrorConverter.execute(response);
  } else {
    return decodeInvalidCredentials(DeccoUtils$Catalyst.resolveResult(t_decode(response._0), "CustomerUpdateErrorConverter.res"));
  }
}

export {
  Decode ,
  decodeInvalidCredentials ,
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
